module.exports = __webpack_public_path__ + "img/IMG_2254_L_BlackMatted.b0411605.jpg";